/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// this updates the currentSize to be an array with one or a combination of [xl, lg, md, sm, xs]
// because our style sheets overlap in media queries these sizes overlap too
// openSize should have higher priority than closeSize
class MediaQueryService {
   $timeout: any
   $window: any
   _currentSize: any
   availableSizes: any
   availableSizesReversed: any
   current: any
   fire: any
   isTouchDevice: any
   media: any
   previous: any
   constructor(hooksService: any, $window: any, $timeout: any) {
      this.createHelperObject = this.createHelperObject.bind(this)
      this.$window = $window
      this.$timeout = $timeout
      this.media = { 
      // These come from the bootstrap media query classes and correspond to our media query size 
      // scss files (responsive-xl, responsive-lg, responsive-md, responsive-sm, responsive-xs)
      // also note that they overlap, because that's what our style sheets do...
         '(min-width: 1401px)': { size: 'xl' },
         '(max-width: 1400px) and (min-width: 1025px)': { size: 'lg' },
         '(max-width: 1024px) and (min-width: 701px)': { size: 'md' },
         '(max-width: 1024px)': { size: 'sm' },
         '(max-width: 700px)': { size: 'xs' }
      }
    
      this._currentSize = []
      this.availableSizes = ['xs', 'sm', 'md', 'lg', 'xl']
      this.availableSizesReversed =  ['xs', 'sm', 'md', 'lg', 'xl'].reverse()
      this.current = {}
      this.previous = {}
      // @ts-ignore msMaxTouchPoints (it is not in navigator)
      this.isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
      hooksService.setHooks(this, 'MediaQueryService', ['change'])
      this.initMediaQueries()
   }

   diffSize(size: any, compareSize: any) {
      const sIdx = this.availableSizes.indexOf(size.size)
      const csIdx = this.availableSizes.indexOf(compareSize.size)
      return sIdx - csIdx
   }

   createHelperObject(size: any) {
      const ret = {
         hasTouch: this.isTouchDevice
      }
      let largestActiveSize = 'xs'
      let smallestActiveSize = 'xl'
      _.map(this.availableSizes, function(avSize: any) {
         // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         ret[avSize] = size.includes(avSize)
         // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         if (ret[avSize]) {
            return largestActiveSize = avSize
         }
      })
      _.map(this.availableSizesReversed, function(avSize: any) {
         // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         if (ret[avSize]) {
            return smallestActiveSize = avSize
         }
      })

      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      ret['size'] = largestActiveSize
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      ret['sizeSmallest'] = smallestActiveSize
      return ret
   }

   // there can be multiple matching sizes due to how our CSS responsive styles overlap - so changing existing @current 
   mediaChangeHandler(e: any) {
      this._currentSize = []
      _.mapObject(this.media, (val: any, key: any) => {
         this.media[key].matchMedia = this.$window.matchMedia(key)
         if (this.media[key].matchMedia.matches) {
            return this._currentSize.push(this.media[key].size)
         }
      })

      this.current = this.createHelperObject(this._currentSize)
      if (!_.isMatch(this.current, this.previous)) {
         this.fire('change', this.current, this.diffSize(this.current, this.previous))
         return this.previous = angular.merge({}, this.current)
      }
   }

   initMediaQueries() {
      const that = this
      _.mapObject(this.media, (val: any, key: any) => {
         this.media[key].matchMedia = this.$window.matchMedia(key)
         if (this.media[key].matchMedia.matches) {
            this._currentSize.push(this.media[key].size)
         }

         // attach event handlers and bind the current scope to the handler function
         return this.media[key].matchMedia.onchange = that.mediaChangeHandler.bind(that)
      })

      this.current = (this.previous = this.createHelperObject(this._currentSize))
      return this.fire('change', this.current, 0)
   }
}

MediaQueryService.$inject = ['hooksService', '$window', '$timeout']

angular.module('summonApp.services')
   .service("mediaQueryService", MediaQueryService)
